import { useEffect, useState, useCallback, useRef } from 'react';
import { apiUpdateClientOfferApproach } from '../../../../../actions/ClientRfpActions';
/**
 * 提案魅力度更新用のuse
 * @param rfp
 * @param viewRequest
 * @param isEnabled
 * @param dispatch
 * @returns {{onChangeInputRange: (function(*=): void), charmPointValue: unknown, onChangeCompleteInputRange: (function(): void), charmPoint}}
 */
const useCharmPoint = (rfp, viewRequest, isEnabled, dispatch) => {
    const { id, is_end: isEnd } = rfp;
    const { id: viewRequestId, offer } = viewRequest;
    const { charm_point: charmPoint } = offer;
    const isEnabledCharmPoint = !isEnd && isEnabled;
    const [charmPointValue, changeCharmPointValue] = useState(charmPoint);
    const charmPointRef = useRef(charmPointValue || 1);
    useEffect(() => {
        const { offer: { charm_point: updateValue }, } = viewRequest;
        changeCharmPointValue(updateValue);
        charmPointRef.current = updateValue || 1;
    }, [viewRequest, changeCharmPointValue, charmPointRef]);
    const onChangeInputRange = useCallback((updateValue) => {
        if (isEnabledCharmPoint) {
            changeCharmPointValue(updateValue);
            charmPointRef.current = updateValue;
        }
    }, [charmPointRef, isEnabledCharmPoint]);
    const onChangeCompleteInputRange = useCallback(() => {
        if (isEnabledCharmPoint) {
            const action = apiUpdateClientOfferApproach(id, viewRequestId, {
                charmPoint: charmPointRef.current,
            });
            dispatch(action);
        }
    }, [id, viewRequestId, dispatch, charmPointRef, isEnabledCharmPoint]);
    return {
        charmPoint,
        charmPointValue,
        isEnabledCharmPoint,
        onChangeCompleteInputRange,
        onChangeInputRange,
    };
};
export const rfpCharmPointUseCase = {
    useCharmPoint,
};
export default rfpCharmPointUseCase;
